import { render, staticRenderFns } from "./bulletinAnnuelle.vue?vue&type=template&id=8d472370&"
import script from "./bulletinAnnuelle.vue?vue&type=script&lang=js&"
export * from "./bulletinAnnuelle.vue?vue&type=script&lang=js&"
import style0 from "./bulletinAnnuelle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports